export { DMS_MODULE } from '../constants';
export const NAME = 'ReportRequest';
export const API_NAME = 'ReportRequest';
export const CRUMB_LABEL_KEY = 'ReportRequest';
export const DOWNLOAD_TEXT = 'Download';
export const NO_UNDERLINE_CLASS = 'empty-hyperlink';
export const SEND_REQUEST = 'SendRequest';
export const SEARCH = 'Search';
